export default __webpack_public_path__ + "static/media/proc.69ce1450.webp";